import {
  Button,
  chakra,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent, ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { FormInput } from "../../../components/Forms";
import * as React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

function SupplierCategoryModal({ modalData, isOpen, onClose, onSubmit }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierSettings.supplierCategories.modal"
  });
  const { t: globalTranslation } = useTranslation("translation");

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: modalData
  });

  const prepareSubmitData = data => {
    onSubmit(modalData?.id, {
      name: data.name
    });
  };

  return isOpen ?
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <chakra.form onSubmit={handleSubmit(prepareSubmitData)}>
          <ModalHeader>{modalData ? t("updateSupplierCategoryHeader") : t("createSupplierCategoryHeader")}</ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <Flex direction="column" gap="2" marginBottom={10}>
              <FormInput
                {...register("name", {
                  required: globalTranslation("entityRequired", { entityName: t("labels.label") })
                })}
                label={`${t("labels.label")} *`}
                errors={errors}
              />
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              {t("buttons.close")}
            </Button>
            <Button colorScheme="customScheme" type="submit">
              {t("buttons.save")}
            </Button>
          </ModalFooter>
        </chakra.form>
      </ModalContent>
    </Modal> : null;
}

export default SupplierCategoryModal;